// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration provided
const firebaseConfig = {
  apiKey: "AIzaSyBh2o1Pv_t5_mANa7oqpC6bd4E3EFgU4Jw",
  authDomain: "heritage-hub-9e697.firebaseapp.com",
  projectId: "heritage-hub-9e697",
  storageBucket: "heritage-hub-9e697.firebasestorage.app",
  messagingSenderId: "1052066028918",
  appId: "1:1052066028918:web:c4c70b4d041c8f8f5aee57",
  measurementId: "G-GC6FBJMETD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth (for user authentication)
export const auth = getAuth(app);

// Initialize Firebase Storage (for image uploads)
export const storage = getStorage(app);

// Initialize Firebase Analytics (for tracking)
export const analytics = getAnalytics(app);

// Initialize Firestore (optional, for metadata storage)
export const db = getFirestore(app);

// Initialize Firebase Storage folders on app startup
// This ensures the folder structure exists
if (typeof window !== 'undefined') {
  // Only run in browser environment
  import('../utils/firebaseStorageInit').then(module => {
    // Make initialization functions globally available
    window.initializeFirebaseStorageFolders = module.initializeStorageFolders;
    window.createFirebaseStorageFolder = module.createStorageFolder;
    
    // Auto-initialize folders on first app load
    const hasInitializedFolders = localStorage.getItem('firebase_folders_initialized');
    if (!hasInitializedFolders) {
      module.initializeStorageFolders().then(() => {
        localStorage.setItem('firebase_folders_initialized', 'true');
        console.log('✓ Firebase Storage folders initialized automatically');
      }).catch(err => {
        console.warn('Could not auto-initialize Firebase Storage folders:', err);
      });
    }
  });
}

// Export app for other Firebase services
export default app;

// Firebase Configuration Constants
// NOTE: secret/private keys must NEVER live here — anything referenced from
// frontend source (hardcoded or via a REACT_APP_* env var) gets bundled into
// the public JS served to every visitor. Only the publishable key belongs here.
export const FIREBASE_CONFIG = {
  PUBLIC_KEY: process.env.REACT_APP_FIREBASE_PUBLIC_KEY || "pk_live_23b7fb7f1W0J7v8c8fd4",
  PROJECT_ID: "heritage-hub-9e697",
  STORAGE_BUCKET: "heritage-hub-9e697.firebasestorage.app"
};

// Image upload constraints
export const IMAGE_CONSTRAINTS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MIN_RESOLUTION: 1200, // 1200x1200px minimum
  RECOMMENDED_RESOLUTION: 2000, // 2000x2000px recommended
  ALLOWED_FORMATS: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
  COMPRESSION_QUALITY: 0.9, // 90% quality for compression
  MAX_IMAGES_PER_PRODUCT: 5
};
